import { Controller } from '@hotwired/stimulus';

// Once, on the order screen: how to put Bud's on the home screen, so the next
// order is one tap. iPhone has no install prompt, so it gets the Share steps;
// Android gets the browser's own install button. Never shown inside the
// installed app, and never again once dismissed.
export default class extends Controller {
  static targets = ['ios', 'android', 'install'];

  connect() {
    if (this.installed() || this.dismissed()) return;

    const ua = navigator.userAgent;
    if (
      /iPhone|iPad|iPod/.test(ua) &&
      /Safari/.test(ua) &&
      !/CriOS|FxiOS/.test(ua)
    ) {
      this.show(this.iosTarget);
    }
    window.addEventListener('beforeinstallprompt', (event) => {
      event.preventDefault();
      this.prompt = event;
      this.show(this.androidTarget);
    });
  }

  async install() {
    if (!this.prompt) return;
    this.prompt.prompt();
    await this.prompt.userChoice;
    this.dismiss();
  }

  dismiss() {
    try {
      localStorage.setItem('buds-install-hint', 'done');
    } catch {
      // Private mode: the hint just shows again next time.
    }
    this.element.hidden = true;
  }

  show(target) {
    this.element.hidden = false;
    target.hidden = false;
  }

  installed() {
    return (
      window.matchMedia('(display-mode: standalone)').matches ||
      navigator.standalone === true
    );
  }

  dismissed() {
    try {
      return localStorage.getItem('buds-install-hint') === 'done';
    } catch {
      return false;
    }
  }
}
